import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { MBC_ASSESSMENT_EMERGENCY_WARNING } from 'constants/mbc'
import TestIds from 'constants/test-ids'
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react'

type MemberIndicationProps = {
  children: ReactNode
  className?: string
}

const MemberIndication = ({ children, className }: MemberIndicationProps) => {
  return (
    <div
      data-testid={TestIds.visits.measurementBasedCare.memberIndication}
      className={classNames('flex flex-col gap-2', className)}
    >
      {children}
    </div>
  )
}

MemberIndication.Banner = ({
  className,
  children = MBC_ASSESSMENT_EMERGENCY_WARNING,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>) => (
  <p
    {...props}
    className={classNames(
      'typography-body-l bg-fuchsia-800 text-white p-2  border rounded-md font-medium tracking-[0.5px]',
      className,
    )}
  >
    {children}
  </p>
)

export default MemberIndication
